import React from "react";
const Loading = () => {
  return <>
    <div className="loading__wrap">
      <div>
        <div className="loaderContainer">
          <div className="customLoader"></div>
        </div>
      </div>
    </div>
  </>
}

export default Loading;

